import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { TONE_CLASS, type Tone } from '@/lib/status'
import { cn } from '@/lib/utils'

export interface StatTileProps {
  label: string
  value: ReactNode
  /** One line under the number: the next slot, the failure count. */
  hint?: ReactNode
  /** Colours the number when it needs attention. */
  tone?: Tone
  /** The whole tile opens this page. */
  to?: string
  className?: string
}

export function StatTile({ label, value, hint, tone, to, className }: StatTileProps) {
  const body = (
    <>
      <div className="text-meta text-muted-foreground">{label}</div>
      <div className={cn('mt-1.5 text-stat font-semibold tabular-nums', tone && TONE_CLASS[tone].text)}>{value}</div>
      {hint && <div className="mt-1.5 truncate text-meta text-muted-foreground">{hint}</div>}
    </>
  )
  const cls = cn('block rounded-lg border border-border bg-card p-4', className)
  if (to) {
    return (
      <Link to={to} className={cn(cls, 'transition-colors hover:border-foreground/20')}>
        {body}
      </Link>
    )
  }
  return <div className={cls}>{body}</div>
}
